// @flow
import {
	type Theme,
	getColor,
	getSize,
	getWeight,
} from "views/resources/theme";
import styled, { type StyledComponent } from "styled-components";
import type { ChildrenArray } from "react";

export type WrapperProps = {|
	bg: ?string,
	fg: ?string,
	fixed: any,
	children?: ChildrenArray<any>,
|};

export const Subtitle = styled.div`
	font-size: 12px;
	font-weight: 500;
	line-height: 15px;
	text-align: center;
`;

export const Wrapper: StyledComponent<WrapperProps, Theme, *> = styled.div`
	/*padding: ${getSize("m")} ${getSize("m")} ${getSize("m")};*/
	top: 0;
	box-sizing: border-box;
	width: 100%;
	height: 60px;
	display: flex;
	margin-bottom: ${(props) => props.styles.marginBottom};
	justify-content: space-between;
	align-items: center;
	padding: 34px 16px;
	background-color: ${(props) => props.bg || getColor("bg")(props)};
	h5 {
		font-weight: ${getWeight("regular")};
		font-size: ${getSize("m")};
		margin: 0;
		color: ${(props) => props.fg || getColor("fg")(props)};
	}
	${(props) => props.fixed && "position: fixed;"}

	svg {
		padding: ${getSize("s")};
	}
	z-index: 998;
`;

export const BackButton: StyledComponent<*, Theme, *> = styled.div`
	&:hover {
		cursor: pointer;
	}
`;
